import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { EditDialogService } from '../../../core/components/editDialog/editDialogService';
import { CommandTemplate } from '../../../core/entities/commandTemplate/commandTemplate';
import { CommandService, Reloadable } from '../../../core/services/command/command.service';
import { MenuItem } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Contact } from 'src/app/rent-module/shared/entities/contact/contact';
import { Task } from 'src/app/rent-module/shared/entities/task/task';
import { TasksService } from 'src/app/rent-module/shared/services/tasks/tasks.service';
import { TranslateService } from '@ngx-translate/core';
import { Address } from 'src/app/shared-module/shared/entities/address/address';
import { AddressService } from 'src/app/tour-planning/shared/services/address/address.service';


@Component({
  selector: 'div[task-row-wide], app-task-row-wide-component',
  templateUrl: './task-row-wide.component.html',
  styleUrls: ['./task-row-wide.component.scss'],
})
export class TaskRowWideComponent implements Reloadable {

  // attribute is to store a string to compare, if the menu items has changed
  private commandsString: string = undefined;
  menuItems: MenuItem[];

  @Input() showFilesButton: boolean = true;
  @Input() showCommentsButton: boolean = true;
  @Input() showOrderNote: boolean = false;

  dialogRef: DynamicDialogRef | undefined;
  _task: Task;
  @Input() set task(task: Task) {
    if(task){
      this._task = task;
      this.buildMenuItems();
    }
  };
  @Input() showCommandMenu: boolean = false;
  @Input() showIconMenu: boolean = true;
  @Output() refetchTasks = new EventEmitter();

  // dynamic labels templates
  availableColumns: any[];
  public defaultColumns = [
    'dueDateTimePeriod',
    'orderNumber',
    'orderCustomerName',
    'state',
  ];
  @Input() columns: string[] = this.defaultColumns;
  @ViewChild('dueDateTimePeriod', { static: true }) dueDateTimePeriod: TemplateRef<any>;
  @ViewChild('completedDateTime', { static: true }) completedDateTime: TemplateRef<any>;
  @ViewChild('orderNumber', { static: true }) orderNumber: TemplateRef<any>;
  @ViewChild('orderCustomerName', { static: true }) orderCustomerName: TemplateRef<any>;
  @ViewChild('addressStreet', { static: true }) addressStreet: TemplateRef<any>;
  @ViewChild('addressPostalCode', { static: true }) addressPostalCode: TemplateRef<any>;
  @ViewChild('addressCity', { static: true }) addressCity: TemplateRef<any>;
  @ViewChild('addessGeocodingGrade', { static: true }) addessGeocodingGrade: TemplateRef<any>;
  @ViewChild('addressSummary', { static: true }) addressSummary: TemplateRef<any>;
  @ViewChild('addressNote', { static: true }) addressNote: TemplateRef<any>;
  @ViewChild('orderLocation', { static: true }) orderLocation: TemplateRef<any>;
  @ViewChild('depot', { static: true }) depot: TemplateRef<any>;
  @ViewChild('state', { static: true }) state: TemplateRef<any>;
  @ViewChild('extendedState', { static: true }) extendedState: TemplateRef<any>;
  getTemplateForColumn(column: any): TemplateRef<any> {
    if (column === 'dueDateTimePeriod') {
      return this.dueDateTimePeriod;
    } else if (column === 'completedDateTime') {
      return this.completedDateTime;
    } else if (column === 'orderNumber') {
        return this.orderNumber;
    } else if (column === 'orderCustomerName') {
      return this.orderCustomerName;
    } else if (column === 'addressStreet') {
      return this.addressStreet;
    } else if (column === 'addressPostalCode') {
        return this.addressPostalCode;
    } else if (column === 'addressCity') {
        return this.addressCity;
    } else if (column === 'addessGeocodingGrade') {
        return this.addessGeocodingGrade;
    } else if (column === 'addressSummary') {
        return this.addressSummary;
    } else if (column === 'addressNote') {
      return this.addressNote;
    } else if (column === 'orderLocation') {
      return this.orderLocation;
    } else if (column === 'depot') {
      return this.depot;
    } else if (column === 'state') {
      return this.state;
    } else if (column === 'extendedState') {
      return this.extendedState;
    }
    
    return undefined; // Default to text template
  }

  constructor(
    public tasksService: TasksService,
    private datePipe: DatePipe,
    private router: Router,
    private addressService: AddressService,
    public dialogService: EditDialogService,
    public commandService: CommandService,
    private translate: TranslateService
   ){
    // Initialize availableColumns with translations
    this.availableColumns = [
      { field: 'dueDateTimePeriod', label: this.translate.instant('sharedModule.taskRowWideComponent.columns.dueDateTimePeriod'), showSpacer: false },
      { field: 'completedDateTime', label: this.translate.instant('sharedModule.taskRowWideComponent.columns.completedDateTime'), showSpacer: true },
      { field: 'orderNumber', label: this.translate.instant('sharedModule.taskRowWideComponent.columns.orderNumber'), showSpacer: true },
      { field: 'orderCustomerName', label: this.translate.instant('sharedModule.taskRowWideComponent.columns.orderCustomerName'), showSpacer: true },
      { field: 'addressStreet', label: this.translate.instant('sharedModule.taskRowWideComponent.columns.addressStreet'), showSpacer: true },
      { field: 'addressPostalCode', label: this.translate.instant('sharedModule.taskRowWideComponent.columns.addressPostalCode'), showSpacer: true },
      { field: 'addressCity', label: this.translate.instant('sharedModule.taskRowWideComponent.columns.addressCity'), showSpacer: true },
      { field: 'addessGeocodingGrade', label: this.translate.instant('sharedModule.taskRowWideComponent.columns.addressGeocodingGrade'), showSpacer: true },
      { field: 'addressSummary', label: this.translate.instant('sharedModule.taskRowWideComponent.columns.addressSummary'), showSpacer: true },
      { field: 'addressNote', label: this.translate.instant('sharedModule.taskRowWideComponent.columns.addressNote'), showSpacer: true },
      { field: 'orderLocation', label: this.translate.instant('sharedModule.taskRowWideComponent.columns.orderLocation'), showSpacer: true },
      { field: 'depot', label: this.translate.instant('sharedModule.taskRowWideComponent.columns.depot'), showSpacer: true },
      { field: 'state', label: this.translate.instant('sharedModule.taskRowWideComponent.columns.state'), showSpacer: false },
      { field: 'extendedState', label: this.translate.instant('sharedModule.taskRowWideComponent.columns.extendedState'), showSpacer: false }
    ];
  }

  reload(): void {
    this.refetchTasks.emit();
  }

  buildArticleString(taskPositions: any[]){
    let articleNumberString = "";
    if(taskPositions && taskPositions.length > 0){
      for (let index = 0; index < taskPositions.length; index++) {
        const element = taskPositions[index];
        articleNumberString = articleNumberString + taskPositions[index].articleNumber;
        if(index < taskPositions.length -1){
          articleNumberString = articleNumberString + ", ";
        }
      }
    }
    return articleNumberString;
  }

  goToOrder(task: Task){
    if(task && task.order && task.order.id){
      this.router.navigate(["./orders/order/" + task.order.id]);
    }
  }

  getContactName(contact: Contact): string {
    return new Contact(contact).getFullName();
  }

  getAddressToolTip(address: Address) {
    if(!address) {
      return null;
    }
    let addressToolTip = address.getAddressString();
    // add the note of the address to the tooltip
    if(address.note){
      addressToolTip += ", " + address.note;
    }
    return addressToolTip;
  }

  /**
   * This method builds the context menu for each row. It stores a string represenation of all 
   * commands to compare if the commands have changed. If they have changed, the menu items are rebuild.
   * This is because of weird behaviour of the primeng menu component.
   */
  buildMenuItems() {
    if(this._task?.commands?.length > 0 && this.commandsString !== JSON.stringify(this._task?.commands)){
      this.commandsString = JSON.stringify(this._task.commands);
      this.menuItems = [];
      this._task.commands.forEach( (command: CommandTemplate) => {
        this.menuItems.push({
          label: command.settings?.label,
          disabled: command.settings?.disabled,
          command: () => {
            this.commandService.execute(this._task, command, this);
          }
        });
      });
    } else {
      this.commandsString = '';
    } 
  }





  shoulShowSpacer(column: string, columns: string[], index: number, isLast: boolean){
    // if last column, no spacer needed
    if(isLast){
      return false;
    }
    let currentColumn = this.availableColumns.find((column) => column.field === columns[index]);
    let nextColumn = this.availableColumns.find((column) => column.field === columns[index + 1]);
    // if we have a next column, check if it should show a spacer
    if(nextColumn !== undefined && !nextColumn.showSpacer){
      return false;
    }
    return currentColumn?.showSpacer;
  }

  _showCommentsButton(){
    // if(this._task?.type === 'nexcore_default_task') {
    //   return false;
    // }
    return this.showCommentsButton;
  }

  _showFilesButton(){
    // if(this._task?.type === 'nexcore_default_task') {
    //   return false;
    // }
    return this.showFilesButton;
  }

  shouldShowOrderNoteButton(): boolean{
    if(!this.showOrderNote){
      return false;
    }
    switch (this._task?.type) {
      case 'nexcore_rental_resourceAssignmenmt_out':
      case 'nexcore_rental_resourceAssignmenmt_in':
      case 'nexcore_rental_resourceAssignmenmt_refuel':
      case 'nexcore_rental_resourceAssignmenmt_review': 
        return true;
      default: 
        return false;
    }
  }

  getCompletedDateTimeTooltip(task: Task){
    if(task.completedDateTime){
      return this.datePipe.transform(task.completedDateTime, 'dd.MM.yyyy HH:mm');
    }
    return undefined;
  }

  getCompletedTooltip(task: Task){
    if(task.completedBy.firstName && task.completedBy.lastName && task.completedDateTime){
      return task.completedBy.firstName + " " + task.completedBy.lastName + " / " + this.datePipe.transform(task.completedDateTime, 'dd.MM.yyyy HH:mm');
    }
    return undefined;
  }
}
